import { AutoPricingService, EventSourceManager } from '@wkda/autopricing-service';
import { createAutoPricing } from './autoPricing';
export function create(apiUrl, _ref) {
  let {
    marketingPropertiesService,
    logger,
    apmLogger,
    config
  } = _ref;
  const autoPricingService = new AutoPricingService(new EventSourceManager('auto-pricing-sse'), apiUrl);
  return createAutoPricing({
    autoPricingService,
    marketingPropertiesService,
    logger,
    apmLogger,
    config
  });
}